export default __webpack_public_path__ + "static/media/pro@2x.5c5268cb.webp";